<template>
  <div class="BoxFront" id="boxfront">
    <div class="contentBoxFront">
      <div class="headerPDV">
        <div class="input-container" style="width: 20%">
          <label for="quantidade" class="name">QUANTIDADE</label>
          <input
            id="quantidade"
            ref="quantityInput"
            type="number"
            class="input"
            v-model="productsSales.quantidade"
            @change="handleCalculateTotal"
            style="background-color: #cbcbcb !important; width: 100%"
            @keyup.enter="focusOnBarcode"
          />
          <div class="underline"></div>
        </div>
        <div class="input-container" style="width: 78%">
          <label for="barcode" class="name">CÓD BARRAS</label>
          <input
            id="barcode"
            ref="barcodeInput"
            type="text"
            class="input"
            v-model="barcodeSearch"
            style="background-color: #cbcbcb !important; width: 100%"
            @keyup.enter="handleItemConfirmation"
            @change="handleCalculateTotal"
          />
          <div class="underline"></div>
        </div>
        <div
          class="iconSearch"
          role="button"
          v-b-modal.modal-products
          @click="findBarCode(barcodeSearch)"
        >
          <b-icon-search scale="1.5" />
        </div>
      </div>

      <div style="display: flex; width: 100%; padding: 10px 50px">
        <div class="contentFront">
          <p class="title">CAIXA LIVRE</p>
          <div>
            <img style="width: 94%; height: 65px" :src="logoBms" />
          </div>
          <div class="formFront">
            <div style="display: flex" v-if="activecodRef"></div>

            <div
              v-if="confirmationPending"
              class="text-center my-2"
              style="display: flex; flex-direction: column"
            >
              <span class="font-weight-bold text-success"
                >Aperte ENTER para adicionar:</span
              >
              <span
                class="font-weight-bold text-success"
                style="text-transform: uppercase"
                >{{ this.nameProduct }}</span
              >
            </div>

            <div class="infoValue">
              <InputQuant
                label="QUANTIDADE"
                :labelFixed="true"
                ref="refQtd"
                type="text"
                :dataInput.sync="productsSales.quantidade"
                @calculateTotal="handleCalculateTotal"
                isSelectAll
              />
              <NewInputMoney
                label="VALOR UNITÁRIO"
                labelFixed
                ref="refVlUnit"
                type="text"
                :dataInput.sync="productsSales.valorUnitario"
                @calculateTotal="handleCalculateTotal"
                isSelectAll
              />

              <div class="inputItemDesc">
                <div
                  style="
                    width: 65%;
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                  "
                >
                  <NewInputMoney
                    v-if="!discountIsCheked"
                    label="DESCONTO"
                    ref="discount"
                    type="text"
                    :dataInput.sync="productsSales.desconto"
                    @calculateTotal="handleCalculateTotal"
                    isSelectAll
                  />

                  <NewInputPercentage
                    v-else
                    label="DESCONTO"
                    type="text"
                    :dataInput.sync="productsSales.desconto"
                    ref="discount"
                    @calculateTotal="handleCalculateTotal"
                    isSelectAll
                  />
                </div>
                <div class="itemToggleDesc" style="height: 35px">
                  <label class="switch col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <input
                      type="checkbox"
                      ref="typeDiscount"
                      @click="alterDiscountIsCheked"
                      v-model="discountIsCheked"
                    />
                    <div class="slider">
                      <span>R$</span>
                      <span>%</span>
                    </div>
                  </label>
                </div>
              </div>

              <NewInputMoney
                label="VALOR TOTAL"
                ref="valorTotal"
                type="text"
                :dataInput.sync="productsSales.valorTotal"
                @calculateTotal="handleCalculateTotal"
                isDisabled
              />
            </div>

            <div class="infoGeneral">
              <span>DATA: {{ displayDateTime }}</span>
              <span>CLIENTE: CONSUMIDOR FINAL</span>
            </div>
          </div>
          <b-modal id="modal-1" hide-footer hide-header size="lg">
            <div>
              <button class="closeModal" @click="$bvModal.hide('modal-1')">
                <b-icon-x scale="1.3"></b-icon-x>
              </button>
              <Products
                :readOrEditProducts="dataProducts"
                @getAllProducts="getProdutos"
              />
            </div>
          </b-modal>
        </div>
        <div class="contentSketch">
          <div class="tableProducts">
            <table style="width: 100%">
              <thead style="border-bottom: 2px solid #b2b2b2; font-size: 12px">
                <tr>
                  <th style="width: 25%">Nome</th>
                  <th style="width: 20%">Quant</th>
                  <th style="width: 20%">Vl. Unitário</th>
                  <th style="width: 15%">Desconto</th>
                  <th style="width: 20%">Vl. Total</th>
                  <th style="width: 15%">Excluir</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="rowProduct"
                  v-for="(product, index) in productsInTable"
                  :key="index"
                >
                  <td style="width: 25%">{{ product.nome }}</td>
                  <td style="width: 20%">{{ product.quantidade }}</td>
                  <td style="width: 20%">
                    {{ formatCurrency(product.valorUnitario) }}
                  </td>
                  <td style="width: 15%">
                    {{ formatCurrency(product.desconto) }}
                  </td>
                  <td style="width: 20%">
                    {{ formatCurrency(product.valorTotal) }}
                  </td>
                  <td style="width: 15%" @click="deleteProductTable(index)">
                    <b-icon-x-circle
                      scale="1.3"
                      class="trashDelete"
                    ></b-icon-x-circle>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            style="
              display: flex;
              width: 100%;
              justify-content: space-between;
              color: #006459;
              font-size: 13px;
              margin-top: 10px;
            "
          >
            <div>
              <span></span>
            </div>
            <div style="display: flex; gap: 10px">
              <span> <strong>ENTER :</strong> Adicionar produto</span> |
              <span><strong>F1:</strong> Limpar Dados </span> |
              <span><strong>F2:</strong> Finalizar Venda</span> |
              <span><strong>F3:</strong> Pesquisar Produtos</span>
            </div>
          </div>
          <div class="content-sketch-btn" style="padding-top: 40px">
            <div class="input-container">
              <label class="name">N° ITENS</label>
              <input
                type="text"
                class="input"
                :value="productsInTable.length"
                readonly
              />
              <div class="underline"></div>
            </div>
            <div class="input-container">
              <label class="name">QTD. PRODUTOS</label>
              <input type="text" class="input" :value="numProd" readonly />
              <div class="underline"></div>
            </div>
            <div class="input-container">
              <label class="name">TOTAL DE PRODUTOS</label>
              <input type="text" class="input" :value="subtotali" readonly />
              <div class="underline"></div>
            </div>
            <div class="input-container">
              <label class="name">TOTAL DE DESCONTOS</label>
              <input type="text" class="input" :value="amountDesc" readonly />
              <div class="underline"></div>
            </div>
            <div class="input-container">
              <label class="name">TOTAL A PAGAR</label>
              <input type="text" class="input" :value="amount" readonly />
              <div class="underline"></div>
            </div>
          </div>
          <div class="content-sketch-btn">
            <button
              class="sketch-btn"
              style="background: #c7bfbf; color: black; border: none"
            >
              LIMPAR - F1
            </button>
            <span v-if="clearConfirm"
              >Pressione <strong style="color: green">ENTER</strong> para
              confirmar ou <strong style="color: red">ESC</strong> para cancelar
              !
            </span>
            <button
              @click="startFinalization"
              class="sketch-btn"
              style="background: #006459; color: white; border: none"
            >
              FINALIZAR - F2
            </button>
          </div>
        </div>
      </div>
      <b-toast
        class="stockToast"
        id="stock-toast"
        variant="primary"
        no-close-button
        static
        auto-hide-delay="5000"
      >
        <span> O Estoque está Zerado ou Negativo. </span>
      </b-toast>
      <ModalReceiveBoxFront
        :dataSale="dataSale"
        :subtotal="subtotali"
        :amountDesc="amountDesc"
        :amount="amount"
        @clearAll="clearAll = $event"
      />
      <b-modal
        id="modal-products"
        ref="modalProducts"
        @shown="isProductModalVisible = true"
        @hidden="isProductModalVisible = false"
        hide-footer
        hide-header
        size="lg"
      >
        <div>
          <button class="closeModal" @click="$bvModal.hide('modal-products')">
            <b-icon-x scale="1.3"></b-icon-x>
          </button>
          <div class="searchContent">
            <div style="display: flex; align-items: center; gap: 2rem">
              <div
                class="searchInput"
                style="height: 100%; align-items: flex-end"
              >
                <input
                  type="text"
                  class="inputSearch"
                  size="sm"
                  placeholder="Pesquisar por..."
                  v-model="textPesquisa"
                  @keyup.enter="readProducts()"
                  ref="productSearchInput"
                />

                <b-button size="sm" @click="readProducts()" class="searchBtn">
                  <b-icon-search></b-icon-search>
                </b-button>
              </div>

              <b-button
                size="sm"
                @click="handleClearDataSearchProducts"
                class="searchBtn"
                style="
                  font-size: 12px;
                  background: #e8e8e882 !important;
                  color: black;
                  border-radius: 5px !important;
                  border: 1px solid #b2b2b2 !important;
                "
              >
                Limpar
              </b-button>
            </div>
            <div class="radio-buttons-container">
              <div class="radio-button">
                <input
                  name="radio-group"
                  id="radioNome"
                  class="radio-button__input"
                  type="radio"
                  v-model="searchType"
                  value="nome"
                />
                <label for="radioNome" class="radio-button__label">
                  <span class="radio-button__custom"></span>
                  Nome
                </label>
              </div>
              <div class="radio-button">
                <input
                  name="radio-group"
                  id="radioCodRef"
                  class="radio-button__input"
                  type="radio"
                  v-model="searchType"
                  value="codReferencia"
                />
                <label for="radioCodRef" class="radio-button__label">
                  <span class="radio-button__custom"></span>
                  Código de Referência
                </label>
              </div>
              <div class="radio-button">
                <input
                  name="radio-group"
                  id="radioCodBarras"
                  class="radio-button__input"
                  type="radio"
                  v-model="searchType"
                  value="codBarras"
                />
                <label for="radioCodBarras" class="radio-button__label">
                  <span class="radio-button__custom"></span>
                  Código de Barras
                </label>
              </div>
            </div>
            <div class="ContentTable">
              <table>
                <thead class="headTable">
                  <tr>
                    <th style="width: 5%">#</th>
                    <th>Nome</th>
                    <th>Valor de Venda</th>
                    <th>Valor Com desconto</th>
                    <th>Cód. Barras</th>
                    <th>Estoque</th>
                  </tr>
                </thead>
                <tbody
                  v-if="this.dataLength > 0"
                  style="color: #3a4750; width: 100%"
                >
                  <tr
                    v-for="(product, index) in dataSearchProducts"
                    :key="product.id"
                    style="
                      text-align: center;
                      height: 30px;
                      cursor: context-menu;
                    "
                    @click="toggleProductSelection(product.id)"
                    :class="{ 'selected-row': selectedProducts[product.id] }"
                  >
                    <td>
                      <label class="custom-checkbox">
                        <input
                          type="checkbox"
                          :checked="!!selectedProducts[product.id]"
                        />
                        <span class="checkmark"></span>
                        {{ index + 1 }}
                      </label>
                    </td>
                    <td>{{ product.nome }}</td>
                    <td v-if="product.valorVenda">
                      {{
                        product.valorVenda.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || "R$ 0,00"
                      }}
                    </td>
                    <td v-else>R$ 0,00</td>
                    <td v-if="product.valorDesconto">
                      {{
                        product.valorDesconto.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        }) || "R$ 0,00"
                      }}
                    </td>
                    <td v-else>R$ 0,00</td>
                    <td>{{ product.codBarras || "0000000" }}</td>
                    <td>{{ product.estoque || "0" }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <td colspan="7">
                    <div class="defaultSearch">
                      <span>Não há dados para exibir ...</span>
                    </div>
                  </td>
                </tbody>
                <div v-if="spinGeneral" class="loadingLazy">
                  <div class="loader"></div>
                </div>
              </table>
            </div>
            <span style="font-size: 12px; color: #006459; margin-top: 10px"
              >- Digite o numero do(s) produto(s) que deseja adicionar.</span
            >
            <span style="font-size: 12px; color: #006459"
              >- Pressione F4 para adicionar os produtos selecionados.</span
            >
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import api from "../../services/axios";
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import logoBms from "../../assets/headerb.png";
import NewInputMoney from "../UI/CustomInputs/NewInputMoney.vue";
import InputQuant from "../UI/CustomInputs/InputQuantPDV.vue";

import NewInputPercentage from "../UI/CustomInputs/NewInputPercentage.vue";
import Products from "../Products/Products.vue";
import ModalReceiveBoxFront from "./Modal-receive-boxFront.vue";
import serviceCustomer from "../../services/serviceCustomer";
import ServiceAccountReceiptBill from "../../services/serviceAccountReceiptBill";
import servicePaymentForm from "../../services/servicePaymentForm";
import serviceSettings from "../../services/serviceSettings";
import serviceEmployees from "../../services/serviceEmployees";
import { mascaraMoeda } from "../../utils/maskMoney";

export default {
  components: {
    Products,
    ModalReceiveBoxFront,
    InputQuant,
    NewInputMoney,
    NewInputPercentage,
  },
  data() {
    return {
      dataSearchProducts: [],
      textPesquisa: "",
      dataLength: 0,
      searchType: "nome",
      selectedProducts: {},
      isProductModalVisible: false,
      logoBms: logoBms,
      isFinalizingSale: false,
      activecodRef: false,
      spinLoading: false,
      spinGeneral: false,
      textToModalLoading: "Processando...",
      barcodeSearch: "",
      debounceTimeout: null,
      displayDateTime: "",
      dateTimeInterval: null,
      confirmationPending: false,
      currentProduct: null,
      nameProduct: "",

      // --- DADOS DA VENDA ---
      productsInTable: [],
      subtotali: "R$ 0,00",
      amount: "R$ 0,00",
      amountDesc: "R$ 0,00",
      numProd: 0,
      clearConfirm: false,
      dataSale: {
        id: "",
        idCliente: "",
        idFuncionario: "",
        data: moment().format("YYYY-MM-DD"),
        dadosAdicionais: "",
        status: "Finalizado(a)", // 'Rascunho' ou 'Finalizado(a)' , Cancelado
        tipo: "PDV", // Identifica que é uma receita agronômica, outros: Pedido, Receita Pedido, PDV
        saleType: "Venda",
        frete: 0,
        desconto: 0,
        tipoDesconto: "Valor Monetário",
        products: [],
        comissao: 0,
        bills: [
          {
            tipo: "entrada",
            idCliente: "",
            idFuncionario: "",
            idFormaPagamento: "",
            idContaRecebimento: "",
            idVenda: "",
            valorTotal: 0.0,
            valorPago: 0.0,
            valorRestante: 0.0,
            data: moment().format("YYYY-MM-DD"),
          },
        ],
      },
      productsSales: {
        id: "",
        idVenda: "",
        idFornecedor: "",
        idProduto: "",
        quantidade: 1,
        altura: "",
        largura: "",
        metragem: "",
        porcentagemPerda: "",
        desconto: 0,
        valorUnitario: 0,
        valorTotal: 0,
        dadosAdicionais: "",
        tipo: "Frente de caixa",
        tipoProduto: "normal",
      },

      clearAll: false,
      isBlockStock: "",
      dataProducts: {},
      productsSelect: [],
      codReferencia: "",
      sendCodRef: false,
      blocked: false,
      typeSearch: false,
      dataCustomers: [],
      dataEmployee: [],
      allAccountReceiptBills: [],
      typeFormPayment: [],
      returnDataSale: [],
      dataReceive: {
        idCliente: "",
        idFuncionario: "",
        idContaRecebimento: "",
        idFormaDePagamento: "",
      },
      discountIsCheked: false,
    };
  },
  methods: {
    ...mapMutations(["SET_DATA_SEARCH_FROM_BOX_FRONT", "SET_DATA_NFE"]),
    async readProducts() {
      if (!this.textPesquisa) return;
      this.spinGeneral = true;
      this.dataSearchProducts = [];
      this.dataLength = 0;

      try {
        const { data } = await api.get(
          `/products/filter/products?q=${this.textPesquisa}&type=${
            this.searchType
          }&page=${1}`
        );
        this.dataLength = data.data.length;
        this.dataSearchProducts = data.data;
      } catch (error) {
        return this.$toast.open({
          message: "Não foi possível listar os produtos",
          type: "warning",
        });
      } finally {
        this.spinGeneral = false;
      }
      if (this.dataLength < 9) {
        this.clearSearch();
      }
    },
    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
    },
    handleClearDataSearchProducts() {
      this.dataSearchProducts = [];
      this.dataLength = 0;

      this.clearSearch();
    },
    toggleProductSelection(productId) {
      if (this.selectedProducts[productId]) {
        this.$delete(this.selectedProducts, productId);
      } else {
        this.$set(this.selectedProducts, productId, true);
      }
    },
    handleProductSelectionByNumber(key) {
      const index = parseInt(key) - 1;
      if (index >= 0 && index < this.dataSearchProducts.length) {
        const product = this.dataSearchProducts[index];
        this.toggleProductSelection(product.id);
      }
    },
    addSelectedProductsToSale() {
      const productIdsToAdd = Object.keys(this.selectedProducts);
      if (productIdsToAdd.length === 0) {
        return this.$toast.open({
          message: "Nenhum produto selecionado.",
          type: "info",
        });
      }

      productIdsToAdd.forEach((productId) => {
        const product = this.dataSearchProducts.find((p) => p.id == productId);

        if (product) {
          const productToAdd = {
            idProduto: product.id,
            nome: product.nome,
            quantidade: 1,
            valorUnitario: product.valorVenda || 0,
            desconto: product.valorDesconto
              ? product.valorVenda - product.valorDesconto
              : 0,
            valorTotal: product.valorDesconto
              ? product.valorDesconto
              : product.valorVenda || 0,
          };

          const productToSave = {
            idProduto: product.id,
            nome: product.nome,
            quantidade: 1,
            valorUnitario: product.valorVenda || 0,
            desconto: product.valorDesconto ? (product.valorVenda - product.valorDesconto) : 0,
            valorTotal: product.valorVenda,
          };

          this.productsInTable.push(productToAdd);
          this.dataSale.products.push(productToSave);
        }
      });

      this.updateTotals();
      this.clearProductSearch();
      this.$bvModal.hide("modal-products");
    },
    clearProductSearch() {
      this.isProductModalVisible = false;
      this.textPesquisa = "";
      this.dataSearchProducts = [];
      this.selectedProducts = {};
      this.dataLength = 0;
    },
    handleGlobalShortcuts(event) {
      if (this.isProductModalVisible) {
        if (event.key === "F4") {
          event.preventDefault();
          this.addSelectedProductsToSale();
        } else if (event.key === "Escape") {
          event.preventDefault();
          this.$bvModal.hide("modal-products");
        } else if (
          !isNaN(parseInt(event.key)) &&
          this.dataSearchProducts.length
        ) {
          event.preventDefault();
          this.handleProductSelectionByNumber(event.key);
        }

        return;
      }

      if (event.key === "F2") {
        event.preventDefault();
        this.startFinalization();
      }

      if (event.key === "F1") {
        event.preventDefault();
        this.clearConfirm = true;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        this.clearConfirm = false;
      }

      if (event.key === "F3") {
        event.preventDefault();
        this.$bvModal.show("modal-products");
        this.$nextTick(() => {
          this.$refs.productSearchInput.focus();
        });
      }

      if (event.key === "Enter") {
        if (this.clearConfirm) {
          this.clearAll = true;
        }
        this.clearConfirm = false;
        if (this.confirmationPending) {
          event.preventDefault();
          this.handleItemConfirmation();
        }
      }
    },
    startFinalization() {
      if (this.productsInTable.length === 0) {
        return this.$toast.open({
          message: "Adicione pelo menos um produto para finalizar a venda.",
          type: "info",
        });
      }
      this.isFinalizingSale = true;
      const defaultCustomer = this.dataCustomers.find(
        (c) => c.nome === "CONSUMIDOR FINAL"
      );
      if (defaultCustomer) {
        this.dataReceive.idCliente = defaultCustomer.id;
      }
      this.$bvModal.show("modal-center1");
    },
    formatCurrency(value) {
      if (isNaN(value)) return "R$ 0,00";
      return parseFloat(value).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },
    async alterDiscountIsCheked() {
      this.discountIsCheked = !this.discountIsCheked;
      this.handleCalculateTotal();
    },
    focusOnBarcode() {
      this.$refs.barcodeInput.focus();
    },

    handleItemConfirmation() {
      if (this.confirmationPending && this.currentProduct) {
        this.addProductToTable();
      }
    },
    clearAllData() {
      this.productsInTable = [];
      this.dataSale = {
        id: "",
        products: [],
        bills: [{ tipo: "entrada", data: moment().format("YYYY-MM-DD") }],
      };
      this.dataReceive = {
        idCliente: "",
        idFuncionario: "",
        idContaRecebimento: "",
        idFormaDePagamento: "",
      };
      this.returnDataSale = [];
      this.updateTotals();
      this.resetInputFields();
      this.isFinalizingSale = false;
    },
    async getCustomersForSelectBox() {
      const { data } = await serviceCustomer.getCustomersForSelectBox();
      this.dataCustomers = data;
    },
    async listEmployeesSelectBox() {
      const { data } = await api.get("/employees/combobox/fill");
      this.dataEmployee = data.data;
    },
    async getAllReceiptBill() {
      this.allAccountReceiptBills =
        await ServiceAccountReceiptBill.fillComobobox();
    },
    async getAllPayment() {
      this.typeFormPayment = await servicePaymentForm.getAllPayment();
    },
    async getProdutos() {
      const { data } = await api.get("/products");
      this.productsSelect = data.data;
    },

    storeProducts() {
      if (this.isBlockStock === "2") {
        const verifyStockRemaining =
          this.productsSelected.estoque - this.productsSales.quantidade;
        if (verifyStockRemaining < 0) {
          return this.$toast.open({
            message:
              "Não foi possivel adicionar o produto! Verifique o estoque.",
            type: "info",
          });
        }
      }
      this.alterDiscountIsChecked();
      if (this.discountIsCheked) {
        this.storeProductsPercentageDiscount();
      } else {
        const { valorUnitario, quantidade, desconto } = this.productsSales;
        const discountPercentage = desconto;
        const discountedPrice = valorUnitario * quantidade - desconto;

        const { id, nome } = this.productsSelected;
        if (Object.keys(this.productsSelected).length) {
          const newProduct = {
            idProduto: id,
            desconto: discountPercentage,
            valorUnitario: valorUnitario,
            valorTotal: valorUnitario * quantidade,
            quantidade: quantidade,
          };

          this.productsInTable.push({
            idProduto: id,
            nome,
            valorUnitario: valorUnitario,
            valorTotal: discountedPrice,
            quantidade,
            desconto: desconto,
          });

          this.dataSale.products.push(newProduct);
        }
      }

      this.calculateSubtotal();
      this.sumOfTotalValue();
      this.sumOfDiscountValue();
      this.clear();
    },

    async findBarCode(barCode) {
      if (!barCode || barCode.trim() === "") return;

      try {
        const { data } = await api.get(
          `products/search/product/by/bar/code?cod=${barCode}`
        );

        if (!data.data) {
          this.currentProduct = null;
          this.confirmationPending = false;
          return this.$toast.open({
            message: "Produto não encontrado com este código de barras.",
            type: "info",
          });
        }

        this.currentProduct = data.data;
        let desconto = 0;
        if (this.currentProduct.valorDesconto > 0) {
          desconto =
            (this.currentProduct.valorVenda -
              this.currentProduct.valorDesconto) *
            (this.productsSales.quantidade || 1);
        }
        const quantity = parseFloat(this.productsSales.quantidade) || 1;
        this.$refs.refQtd.valueInput = quantity;

        const subtotal =
          (this.currentProduct.valorVenda || this.currentProduct.valor) *
            quantity -
          desconto;
        this.$refs.refVlUnit.valueInput =
          this.currentProduct.valorVenda || this.currentProduct.valor;
        this.productsSales.valorUnitario =
          this.currentProduct.valorVenda || this.currentProduct.valor;
        this.$refs.discount.valueInput = desconto;
        this.productsSales.desconto = desconto;
        this.$refs.valorTotal.valueInput = subtotal;
        this.productsSales.valorTotal = subtotal;

        this.nameProduct = this.currentProduct.nome;

        this.confirmationPending = true;
      } catch (error) {
        this.$toast.open({ message: "Erro ao buscar produto.", type: "error" });
        this.resetInputFields();
      }
    },

    async findCodRef() {
      try {
        this.sendCodRef = true;
        const { data } = await api.get(
          `products/search/product/by/bar/code/ref?codReferencia=${this.codReferencia}`
        );
        this.productsSelected = data.data;
        if (data.data === null || data.data === undefined || data.data === "") {
          return this.$toast.open({
            message: "Não foi encontrado produto com esse código de referência",
            type: "info",
          });
        }
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: "Ops... Houve algum erro!",
            type: "info",
          });
      } finally {
        this.sendCodRef = false;
        this.codReferencia = "";
      }
    },

    addProductToTable() {
      let discountValue = 0;

      if (this.discountIsCheked) {
        const result = (
          this.productsSales.valorTotal *
          (this.productsSales.desconto / 100)
        ).toFixed(2);

        discountValue = parseFloat(result || 0);
      } else {
        discountValue = this.productsSales.desconto || 0;
      }
      let totalprod =
        this.productsSales.valorUnitario * this.productsSales.quantidade -
        discountValue;

      this.productsInTable.push({
        idProduto: this.currentProduct.id,
        nome: this.currentProduct.nome,
        valorUnitario: this.productsSales.valorUnitario,
        valorTotal: totalprod,
        quantidade: this.productsSales.quantidade,
        desconto: discountValue || 0,
      });

      this.dataSale.products.push({
        idProduto: this.currentProduct.id,
        desconto: discountValue,
        valorUnitario: this.productsSales.valorUnitario,
        valorTotal:
          this.productsSales.valorUnitario * this.productsSales.quantidade,
        quantidade: this.productsSales.quantidade,
      });

      this.updateTotals();
      this.resetInputFields();
    },

    resetInputFields() {
      this.productsSales.quantidade = 1;
      this.productsSales.desconto = 0;
      this.productsSales.valorUnitario = 0;
      this.barcodeSearch = "";
      this.currentProduct = null;
      this.confirmationPending = false;
      this.$nextTick(() => {
        this.$refs.quantityInput.focus();
      });
      this.$refs.refQtd.valueInput = 1;
      this.$refs.refVlUnit.valueInput = 0;
      this.$refs.discount.valueInput = 0;
      this.$refs.valorTotal.valueInput = 0;
      this.nameProduct = "";
      this.discountIsCheked = false;
    },

    updateTotals() {
      this.calculateSubtotal();
      this.sumOfTotalValue();
      this.sumOfDiscountValue();
    },
    deleteProductTable(index) {
      this.productsInTable.splice(index, 1);
      this.dataSale.products.splice(index, 1);
      this.updateTotals();
    },

    sumOfTotalValue() {
      const total = this.productsInTable.reduce(
        (sum, item) => sum + item.valorTotal,
        0
      );
      this.amount = this.formatCurrency(total);
    },

    sumOfDiscountValue() {
      const totalDiscount = this.productsInTable.reduce(
        (sum, item) => sum + parseFloat(item.desconto),
        0
      );
      this.amountDesc = this.formatCurrency(totalDiscount);
    },
    handleCalculateTotal() {
      const amount = Number(this.productsSales.quantidade);
      this.$refs.refQtd.valueInput = amount;
      const unitaryValue = this.productsSales.valorUnitario;
      const totalValue = amount * unitaryValue;
      if (!this.$refs.valorTotal) return;
      this.productsSales.valorTotal = totalValue;

      let discountValue = 0;

      if (this.discountIsCheked) {
        const result = (
          this.productsSales.valorTotal *
          (this.productsSales.desconto / 100)
        ).toFixed(2);

        discountValue = parseFloat(result || 0);
      } else {
        discountValue = this.productsSales.desconto || 0;
      }

      this.$refs.valorTotal.valueInput = totalValue - discountValue;
      this.$refs.refVlUnit.valueInput = unitaryValue;
      this.productsSales.valorUnitario = unitaryValue;
    },
    calculateSubtotal() {
      const subtotal = this.productsInTable.reduce(
        (sum, item) => sum + item.valorTotal + item.desconto,
        0
      );
      this.numProd = this.productsInTable.reduce(
        (sum, item) => sum + parseInt(item.quantidade || 0),
        0
      );

      this.subtotali = this.formatCurrency(subtotal);
    },
    assignBarCode(product) {
      this.dataSale.tipoDesconto = "Valor Monetário";
      this.productsSelected = product;
      this.productsSales.idProduto = product.id;
      this.productsSales.nome = product.nome;
      this.productsSales.quantidade = "1";
      this.productsSales.desconto = 0;
      if (product.valorVenda === 0) {
        this.productsSales.valorUnitario = product.valor;
        this.productsSales.valorTotal = product.valor;
      } else {
        this.productsSales.valorUnitario = product.valorVenda;
        this.productsSales.valorTotal = product.valorVenda;
      }

      this.storeProducts();
    },

    storeProductsPercentageDiscount() {
      const { valorUnitario, quantidade, desconto } = this.productsSales;
      if (!this.productsSelected || !this.productsSelected.id) {
        return;
      }

      if (
        this.dataSale.id !== "" &&
        this.dataSale.products[0].idProduto !== ""
      ) {
        this.productsSales.desconto =
          this.productsSales.valorTotal -
          this.productsSales.valorTotal * (this.productsSales.desconto / 100);
      } else if (this.productsSales.desconto !== 0) {
        this.productsSales.desconto = desconto / 100;
      }

      const discountedPrice =
        valorUnitario -
        (valorUnitario * this.productsSales.desconto).toFixed(2);

      const newProduct = {
        ...this.productsSales,
        idProduto: this.productsSelected.id,
        desconto: desconto,
        valorUnitario: valorUnitario,
        valorTotal: quantidade * valorUnitario,
      };

      const { id, nome, refFiscal, ncm, cest } = this.productsSelected;
      const valorUnitarioFormatted = valorUnitario;
      const descontoFormatted = desconto;

      this.productsInTable.push({
        idProduto: id,
        nome,
        valorUnitario: valorUnitarioFormatted,
        valorTotal: quantidade * discountedPrice,
        quantidade,
        desconto: descontoFormatted,
        refFiscal,
        ncm,
        cest,
      });

      this.dataSale.products.push(newProduct);
    },

    clear() {
      this.productsSales.valorUnitario = 0;
      this.productsSales.quantidade = "1";
      this.productsSales.desconto = 0;
      // this.$refs.valor.valueInput = 0;
      // this.$refs.quantidade.valueInput = "1";
      // this.$refs.desconto.valueInput = 0;
      this.productsSelected = "";
    },

    selectPayment() {
      this.blocked = false;
      const moneyPayment = this.typeFormPayment.find(
        (formPayment) => formPayment.id === this.dataReceive.idFormaDePagamento
      );
      if (moneyPayment.tipo === "Dinheiro") {
        this.blocked = true;
        const accountPayment = this.allAccountReceiptBills.find(
          (account) => account.nome === "CAIXA GAVETA"
        );
        this.dataReceive.idContaRecebimento = accountPayment.id;

        // this.$refs.refContaDeRecebimento.valueItems = accountPayment.id;
      }
    },
    async calculateComissao() {
      const data = await serviceEmployees.findById(
        this.dataReceive.idFuncionario
      );
      if (data.comissao) {
        const total =
          parseFloat(data.comissao) * (mascaraMoeda(this.amount) / 100);
        this.dataSale.comissao = total.toFixed(2);
      }
    },

    alterDiscountIsChecked() {
      if (this.discountIsChecked === true) {
        this.dataSale.tipoDesconto = "Porcentagem";
      } else {
        this.dataSale.tipoDesconto = "Valor Monetário";
      }
    },

    habilityCodeBar() {
      if (this.activeBarCode) {
        document.body.addEventListener("keydown", this.handleKeyDown);
      }

      if (!this.activeBarCode) {
        document.body.removeEventListener("keydown", this.handleKeyDown);
      }
    },

    handleKeyDown(event) {
      if (event) {
        this.keyCodes.push(event.key);
        const codes = this.keyCodes.filter((item) => !isNaN(parseInt(item)));

        if (codes && codes.length) {
          const mergedCodes = codes.join("");
          if (isNaN(event.key) && mergedCodes.length > 1) {
            this.findBarCode(parseInt(mergedCodes));
          }
        }
      }
    },

    handleEditNFe() {
      if (Object.keys(this.dataNFe).length) {
        this.assignToEditNfce(this.dataNFe);
      }
    },

    assignToEditNfce(data) {
      if (Object.keys(data).length) {
        this.dataSale.products = data.products.noteItem;
        this.dataSale.id = data.idVenda;
        this.dataSale.idCliente = data.idCliente;
        this.dataSale.idFuncionario = "";
        this.dataSale.data = data.data_nfe;
        this.dataSale.dadosAdicionais = data.informacoes_complementares;
        this.dataSale.status = "Venda";
        this.dataSale.tipo = "Frente de caixa";
        this.dataSale.frete = data.frete;
        this.dataSale.tipoDesconto = "Valor Monetário";
        this.editBoxFront(this.dataSale);
        this.storeProducts();
        this.sumOfDiscountValue();
        this.SET_DATA_SEARCH_FROM_BOX_FRONT({});
      }
    },

    editBoxFront() {
      if (this.dataSale.tipoDesconto === "Porcentagem") {
        const productEditFormated = this.dataSale.products.map((product) => {
          const discountValue = (
            product.valorTotal *
            (product.desconto / 100)
          ).toFixed(2);

          return {
            idProduto: product.idProduto,
            nome: product.nome,
            desconto: discountValue,
            valorUnitario: product.valorUnitario,
            valorTotal: product.valorTotal - discountValue,
            quantidade: product.quantidade,
          };
        });

        this.discountIsChecked = true;
        this.productsInTable = productEditFormated;
      } else {
        const productEditFormated = this.dataSale.products.map((product) => {
          return {
            idProduto: product.idProduto,
            nome: product.nome,
            valorUnitario: product.valorUnitario,
            valorTotal: product.valorTotal - product.desconto,
            quantidade: product.quantidade,
            desconto: product.desconto,
          };
        });
        this.productsInTable = productEditFormated;
      }
    },

    async getConfig() {
      const result = await serviceSettings.findSettingsAtm();
      if (Object.keys(result).length) {
        this.isBlockStock = result.venda.bloqueio_estoque;
      }
    },
    updateTime() {
      this.displayDateTime = moment().format("DD/MM/YYYY - HH:mm:ss [HRS]");
    },
  },

  mounted() {
    this.handleEditNFe();
    this.getCustomersForSelectBox();
    this.listEmployeesSelectBox();
    this.getAllReceiptBill();
    this.getAllPayment();
    this.getProdutos();
    this.getConfig();
    this.$nextTick(() => {
      this.$refs.quantityInput.focus();
    });

    this.updateTime();
    this.dateTimeInterval = setInterval(this.updateTime, 1000);
    if (Object.keys(this.dataSearchFromBoxFront).length) {
      Object.assign(this.dataSale, this.dataSearchFromBoxFront);
      this.editBoxFront(this.dataSale);
      this.storeProducts();
      this.sumOfDiscountValue();
      this.SET_DATA_SEARCH_FROM_BOX_FRONT({});
    }
    window.addEventListener("keydown", this.handleGlobalShortcuts);
  },

  computed: {
    ...mapState(["dataSearchFromBoxFront", "dataNFe"]),
    validatorDesc() {
      if (this.productsInTable.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    clearAll(newValue) {
      if (newValue) {
        this.productsInTable = [];
        this.dataSale.products = [];
        this.dataSale.bills = [
          {
            tipo: "entrada",
            idCliente: "",
            idFuncionario: "",
            idFormaPagamento: "",
            idContaRecebimento: "",
            idVenda: "",
            valorTotal: 0.0,
            valorPago: 0.0,
            valorRestante: 0.0,
            data: moment().format("YYYY-MM-DD"),
          },
        ];
        this.updateTotals();
        this.clearAll = false;
        this.resetInputFields();
      }
    },
    barcodeSearch(barCode) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        if (barCode.length >= 3) {
          this.findBarCode(barCode);
        }
      }, 500);
    },
  },
  beforeDestroy() {
    document.body.removeEventListener("keydown", this.handleKeyDown);
    clearInterval(this.dateTimeInterval);
    window.removeEventListener("keydown", this.handleGlobalShortcuts);
  },
};
</script>
<style scoped>
.BoxFront {
  display: flex;
  width: 100%;
  height: 100vh;
  background-image: url("../../assets/bg.jpeg");
  background-size: cover;
}

.contentBoxFront {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
}

.headerPDV {
  display: flex;
  width: 100%;
  padding: 15px 60px 0 50px;
  gap: 20px;
  align-items: flex-end;
}

.contentFront {
  display: flex;
  flex-direction: column;
  width: 20%;
  height: auto;
  gap: 2px;
}
.selected-row {
  background-color: #d1e7fd !important;
  font-weight: bold;
}
.searchContent {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 20px;
}

.searchInput {
  width: 100%;
  display: flex;
}
.inputSearch {
  width: 100%;
  border: solid 1px #e3e0e0;
  border-radius: 5px 0 0 5px;
  padding: 5px 10px;
  font-size: 14px;
  outline: none;
}
.searchBtn {
  height: 31px;
  position: relative;
  background: #006459;
  color: whitesmoke;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}
.form-control:focus {
  box-shadow: none;
  border-color: #c3c1c1;
}
.radio-buttons-container {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.radio-button {
  display: inline-block;
  position: relative;
  cursor: pointer;
}
.radio-button__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.radio-button__label {
  display: inline-block;
  padding-left: 30px !important;
  margin-bottom: 10px !important;
  position: relative;
  font-size: 14px;
  color: #363636;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}
.radio-button__custom {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #555;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}
.radio-button__input:checked + .radio-button__label .radio-button__custom {
  transform: translateY(-50%) scale(0.9);
  border: 5px solid #006459;
  color: #006459;
}
.radio-button__input:checked + .radio-button__label {
  color: #006459;
}
.radio-button__label:hover .radio-button__custom {
  transform: translateY(-50%) scale(1.2);
  border-color: #006459;
  box-shadow: 0 0 10px #00645980;
}
.ContentTable {
  display: flex;
  flex-direction: column;
  max-height: 50vh;
  overflow: auto;
  width: 100%;
  max-width: 100%;
  font-size: 12px;
}
.headTable {
  color: #3a4750;
  border-bottom: 1px dashed #3a4750;
  background: #3a4750;
  text-align: center;
  height: 29px;
}

.trTable {
  text-align: center;
  height: 29px;
  cursor: context-menu;
  font-size: 12px;
}
tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-weight: 500;
  font-size: 12px;
}

td {
  text-transform: capitalize;
}
.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 30vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}
.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  gap: 5px;
  color: #333;
  transition: color 0.3s;
}
.custom-checkbox input[type="checkbox"] {
  display: none;
}
.custom-checkbox .checkmark {
  width: 13px;
  height: 13px;
  border: 2px solid #333;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
  transform-style: preserve-3d;
}
.custom-checkbox .checkmark::before {
  content: "\2713";
  font-size: 10px;
  color: transparent;
  transition: color 0.3s, transform 0.3s;
}
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #006459;
  border-color: #333;
  transform: scale(1.1) rotateZ(360deg) rotateY(360deg);
}
.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
  color: #fff;
}
.custom-checkbox:hover {
  color: #666;
}
.custom-checkbox:hover .checkmark {
  border-color: #666;
  background-color: #f0f0f0;
  transform: scale(1.05);
}
.custom-checkbox input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  outline: none;
}
.custom-checkbox .checkmark,
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  transition: background-color 1.3s, border-color 1.3s, color 1.3s,
    transform 0.3s;
}
.title {
  font-size: 30px;
  color: #5e8bb9;
  font-weight: 600;
  letter-spacing: 2px;
  margin: 0;
}

.payment-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  margin-bottom: 20px;
}
.inputItemDesc {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 10px;
}

.itemToggleDesc {
  width: 52px;
  position: relative;
}
.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #f8f8f8;
  color: #070707;
  border-radius: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 100%;
  font-size: 12px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 12px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 5px;
  background-color: #006459;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #f8f8f8;
  color: #070707;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #006459;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.actions-panel {
  display: flex;
  justify-content: space-between;
}

.totals-display {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  align-items: flex-end;
  padding-right: 20px;
}

.totals-display span {
  text-align: end;
  font-size: 13px;
}

.totals-display p {
  text-align: end;

  font-size: 12px;
}

.input-container {
  position: relative;
  width: 100%;
}

label {
  display: block;
  color: #006459;
  font-weight: 600;
  font-size: 13px;
  margin: 0 !important;
}

.input[type="text"] {
  padding: 7px;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  background-color: #f1f1f1;
  color: #333;
  width: 100%;
  outline: none;
}
.input[type="number"] {
  padding: 7px;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  background-color: #f1f1f1;
  color: #333;
  width: 100%;
  outline: none;
}

.underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #4158d0;
  background-image: linear-gradient(
    43deg,
    #006459 0%,
    #029b89 46%,
    #ffcc70 100%
  );
  transition: width 0.3s;
}

.input[type="text"]:focus + .underline {
  width: 100%;
}

@keyframes floating-label {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(-25px);
    opacity: 0;
  }
}

.input[type="text"]:placeholder-shown + label {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 14px;
  color: #777;
  pointer-events: none;
  transition: transform 0.3s, font-size 0.3s, color 0.3s;
}

.input[type="text"]:focus:not(:placeholder-shown) + label {
  transform: translateY(-25px);
  font-size: 12px;
  background-color: #4158d0;
  background-image: linear-gradient(
    43deg,
    #4158d0 0%,
    #c850c0 46%,
    #ffcc70 100%
  );
  animation: floating-label 0.3s forwards;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px !important;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050 !important;
  box-shadow: none;
}

.form-control {
  box-shadow: none;
  position: relative;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.screenProducts {
  align-items: center;
  background: white;
  cursor: pointer;
  display: flex;
  width: 2em;
  height: 2em;
  justify-content: center;
}
/*  ------------------ */

.fixedSelect {
  position: absolute;
  font-size: 10px;
  bottom: 15px;
  left: 10px;
  background-color: #ffffff;
  padding: 0 0.4em;
}

/* ----------------------------  */

.infoValue {
  gap: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.infoGeneral {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 12px;
  color: #006459;
  font-weight: 600;
  gap: 5px;
}
.formFront {
  width: 95%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  gap: 10px;
}

.cyberpunk-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #555151;
  border-radius: 5px;
  background-color: transparent;
  display: inline-block;
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}

.cyberpunk-checkbox:before {
  content: "";
  background-color: #006256;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 8px;
  height: 8px;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}

.cyberpunk-checkbox:checked:before {
  transform: translate(-50%, -50%) scale(1);
}

.cyberpunk-checkbox-label {
  font-size: 12px;
  color: black;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
}

.content-form-btn {
  display: flex;
  width: 87%;
  justify-content: space-between;
}

.form-btn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #fbfbfb;
  border: 1px solid green;
  color: green;
  border-radius: 3px;
  width: 35%;
  height: 28px;
  margin-top: 90px;
  box-shadow: 0px 1px 1px 0px black;
}

.form-btn:hover {
  border: 1px solid green;
  color: green;
  background: whitesmoke;
}

.contentSketch {
  width: 80%;
  border: 1px solid #eeeeee;
  border-radius: 7px;
  position: relative;
  padding: 0 10px 10px 10px;
}

.contentSketch p {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.tableProducts {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  height: 50vh;
  overflow: scroll;
  text-align: center;
  background: #fffcfc;
}

.styleTotal {
  display: flex;
  width: 100%;
  padding: 0 100px;
  background: #e3e9e6;
  font-size: 12px;
  height: 30px;
  gap: 2vw;
  font-weight: bold;
  justify-content: flex-end;
  align-items: center;
}

tbody {
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow: scroll;
}

tr:nth-child(even) {
  background: white;
}

tr {
  background: #fffcfc;
}

.rowProduct {
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #f1efef;
}

.trashDelete {
  color: red;
  cursor: pointer;
}

.sketch-btn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgb(255, 255, 255);
  border: 1px solid green;
  color: green;
  border-radius: 3px;
  width: 18.5%;
  height: 28px;
  gap: 10px;
  box-shadow: 0px 1px 1px 0px #686868;
  letter-spacing: 1px;
}

.sketch-btn:hover {
  background: whitesmoke;
  border: 1px solid green;
  color: green;
}

.content-sketch-btn {
  display: flex;
  width: 100%;
  padding-top: 10px;
  gap: 20px;
  justify-content: space-between;
}

.sketch-btns {
  width: 100%;
  display: flex;
  gap: 20px;
  justify-content: flex-end;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}
.iconSelectBarCode {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: #709e89;
  color: black;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.iconSearch {
  background-color: #709e89;
  color: black;
  height: 33px;
  width: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.stockToast {
  position: absolute;
  right: 20px;
  display: flex;
}

.stockToast span {
  color: black;
}

.iconSelectCodRef {
  background-color: #c1c1c1;
  color: black;
  height: 30px;
  width: 120px;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.alertStock {
  font-size: 10px;
  color: #344d67;
  padding-left: 10px;
}

.alertStockNegative {
  font-size: 10px;
  color: #ff1d08;
  padding-left: 10px;
}

.loadingRef {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
}

.switch {
  font-size: 12px;
  position: relative;
  display: inline-block;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 12px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  z-index: 300;
}

th {
  font-weight: normal;
  font-size: 12px;
}

td {
  text-transform: capitalize;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .contentFront {
    margin-left: 15px;
  }

  .contentSketch {
    width: 60%;
  }

  .title {
    margin-top: 62px;
    font-size: 14px;
  }

  .titleRight {
    margin-top: 62px;
    font-size: 14px;
  }

  .formFront {
    width: 98%;
    margin-top: 35px;
  }

  .infoValue[data-v-36ca50e2] {
    gap: 0px;
  }

  .form-btn {
    font-size: 10px;
    width: 45%;
    height: 28px;
    margin-top: 80px;
  }

  .tableProducts {
    padding: 15px 7px;
  }

  .cyberpunk-checkbox-label {
    font-size: 10px;
  }

  .content-form-btn {
    width: 92%;
  }

  .slider {
    width: 40px !important;
  }

  .styleTotal {
    padding: 0 40px;
    font-size: 11px;
  }

  .content-sketch-btn {
    right: 30px;
  }

  .sketch-btn {
    width: 140px;
    height: 29px;
  }
}

@media screen and (max-width: 700px) {
  .BoxFront {
    flex-direction: column;
  }

  .contentFront {
    width: 80%;
    margin-left: 40px;
  }

  .contentSketch {
    width: 100%;
    margin-top: 30px;
  }

  .content-form-btn {
    width: 95%;
  }

  .form-btn {
    width: 40%;
    height: 24px;
    margin-top: 35px;
  }

  .switch {
    right: -5px !important;
  }

  .infoValue {
    margin-top: 1rem !important;
  }

  .titleRight {
    font-size: 1rem;
    padding: 0;
    margin-left: 40px;
  }

  .tableProducts {
    padding: 20px;
    height: auto;
    max-height: 50vh;
  }

  .content-sketch-btn {
    bottom: 20px;
    right: 20px;
    position: fixed;
  }
  .sketch-btn {
    width: 150px;
    height: 28px;
    margin-top: 0px;
    gap: 0px;
  }
}
</style>